var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2317 4.08836L10.0834 7.51669C7.97504 8.30503 6.25171 10.7984 6.25171 13.0534V26.675C6.25171 28.8384 7.68173 31.68 9.4234 32.9817L17.3067 38.8667C19.8917 40.81 24.145 40.81 26.73 38.8667L34.6134 32.9817C36.355 31.68 37.785 28.8384 37.785 26.675V13.0534C37.785 10.7984 36.0617 8.30503 33.9533 7.51669L24.805 4.08836C23.2467 3.52003 20.7533 3.52003 19.2317 4.08836Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.4167C26.05 28.4167 29.3333 25.1334 29.3333 21.0833C29.3333 17.0332 26.05 13.75 22 13.75C17.9499 13.75 14.6666 17.0332 14.6666 21.0833C14.6666 25.1334 17.9499 28.4167 22 28.4167Z",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4583 18.7916V20.4966C22.4583 21.1383 22.1283 21.7433 21.56 22.0733L20.1666 22.9166",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityTime);
export default __webpack_public_path__ + "static/media/security-time.cd4edf54a7fccb131967ec5ceb62c15d.svg";
export { ForwardRef as ReactComponent };